import React from 'react';


import { CustomInputWithOutIcon } from './CustomInput';
import { useTranslation } from 'react-i18next';

export const CustomSwitcher = (props) => {
  /**
   * Accessibility infos: https://mui.com/base/react-switch/#accessibility
   *                      https://www.w3.org/TR/wai-aria-practices/#switch
   */

  const {
    dataCy,
    htmlTag,
    idSwitcher,
    label,
    icon,
    defaultValue, 
    callBackFunction, 
    customStyle,
    disabled=false
  } = props;

  const roleSwitchStyle = {
    cursor: disabled ? 'auto': 'pointer',
    userSelect: 'none',
    position: 'relative',
    display: 'inline-block'
  };
  
  const switchLabelStyle = {
    color: customStyle.primaryContrast,
    fontSize: '1em',
    display: 'inline-block',
    margin: '0.2em',
  };

  const switchStyle = {
    position: 'relative',
    display: 'inline-block',
    borderRadius: '12px',
    border: `2px solid ${customStyle.thumb}`,
    marginLeft: '1em',
    height: '20px',
    width: '40px',
    background: defaultValue ? customStyle.backgroundActive : customStyle.background,
    verticalAlign: 'middle',
    opacity: disabled ? 0.5 : 1
  };

  const switchToggleStyle = {
    position: 'absolute',
    top: '2px',
    left: props.defaultValue ? '21px' :'2px',
    display: 'inline-block',
    border: `2px solid ${defaultValue ? customStyle.activeThumbColor : customStyle.thumb}`,
    borderRadius: '8px',
    height: '12px',
    width: '12px',
    background: props.defaultValue ? customStyle.activeThumbColor : customStyle.thumb,
    transition: '0.3s ease left'
  };

  
  const {t} = useTranslation();
  

  const handleSwitch = () => {
    if (defaultValue === true) {
      callBackFunction(false);
    } else {
      callBackFunction(true);
    }
  };

  const handleKeyDown = (event) => {
    // Only do something when space or return is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      handleSwitch();
    }
  };

  const styles = {
    label: {
      whiteSpace: 'normal',
      color: '#000000'
    }
  };

  return (
    <div 
      data-cy={dataCy} 
      role="switch" 
      disabled={true}
      aria-checked={defaultValue} 
      onKeyDown={(event) => handleKeyDown(event)} 
      onClick={() => handleSwitch()}
      style={roleSwitchStyle} 
      tabIndex="0"
    >
      <CustomInputWithOutIcon 
        sxStack={{
          display: 'flex', 
          justifyContent: 'space-between',
        }}
        icon={icon} 
        styleLabel={styles.label}
        label={label} 
        htmlTag={htmlTag} 
        direction='row'
      >
        <div>
          <span id={idSwitcher} style={switchStyle}>
            <span style={switchToggleStyle}></span>
          </span>
          <span aria-hidden="true" style={switchLabelStyle}>
            {defaultValue ? t('form.switch-value-on-label'): t('form.switch-value-off-label')}
          </span>
        </div>
      </CustomInputWithOutIcon>
    </div>


  );
};
